import { Injectable, Inject, PLATFORM_ID} from '@angular/core';
import { isPlatformServer} from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { UserService } from '../services/user_service';
import { User } from '../types/user';

@Injectable({
  providedIn: 'root'
})
export class UserProfileAtResolver {

  constructor(@Inject(PLATFORM_ID) private platformId: string, 
              private userService: UserService, 
              private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<User> {
    if (isPlatformServer(this.platformId)) {
      return Promise.resolve(null);
    }
    
    const userName = route.paramMap.get('username');
    
    return this.userService.getUserProfileByUsername(userName).then((user: User) => {
      return user;
    }).catch(err => {
      this.router.navigate(['/']);
      return Promise.reject(err); 
    });
  }
}